export default{
    //设置表头行的样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background: #F7F7FA; height:40px; text-align: center; font-family:'.PingFang SC';font-style: normal;font-weight: 600;font-size: 14px;line-height: 40px;color: #000000; padding:5px 0;";
    },
    //设置表头行左对齐的样式
    tableHeaderColorLeft({ row, column, rowIndex, columnIndex }) {
        return "background: #F7F7FA; height:40px;text-align: left; font-family:'.PingFang SC';font-style: normal;font-weight: 600;font-size: 14px;line-height: 40px;color: #000000; padding:5px 0;";
    },
    //设置表头行的样式
    tableHeaderColorOrder({ row, column, rowIndex, columnIndex }) {
        return "background: #F7F7FA; height:40px; font-family:'.PingFang SC';font-style: normal;font-weight: 600;font-size: 14px;line-height: 40px;color: #000000; padding:5px 0;";
    },
    // 设置单元格的样式高度50px
    cellStyle({ row, rowIndex }) {
        return "text-align:center;height:50px; line-height: 50px; font-size:14px;color: #000000; font-family: '.PingFang SC';font-style: normal;font-weight: 400; padding:0;";
    },
    // 设置单元格的样式左对齐高度50px
    cellStyleLeft({ row, rowIndex }) {
        return "text-align:left;height:50px; line-height: 50px; font-size:14px;color: #000000; font-family: '.PingFang SC';font-style: normal;font-weight: 400; padding:0;";
    },
    // 设置单元格的样式高度20px
    cellStyleOrder({ row, rowIndex }) {
        return "height:50px; line-height: 50px; font-size:14px;color: #000000; font-family: '.PingFang SC';font-style: normal;font-weight: 400; padding:0;";
    },
    // 设置单元格的样式高度20px
    cellStyleDialog({ row, rowIndex }) {
        return "text-align:center;height:50px; line-height: 50px; font-size:14px; color: #666666; font-family: '.PingFang SC';font-style: normal;font-weight: 400; padding:0;";
    },
    // 设置行样式
    rowStyle({row, rowIndex}){
        return "text-align:center;height:20px;font-size:14px;font-weight:400;"
    },
}